import React from 'react'

const LabView = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Process Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>Lab View</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/labview.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>LabVIEW (Laboratory Virtual Instrument Engineering Workbench):</h2>
                        <p className="mbot25">
                            Our expertise in LabVIEW allows us to develop custom control and measurement applications.
                            We provide solutions for data acquisition, instrument control,
                            and automation tailored to your specific requirements.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LabView
